var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function Store(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14zm-4 7.73c-.016.023-.92 1.27-3 1.27-2.081 0-2.984-1.247-3-1.27-.016.023-.919 1.27-3 1.27-1.246 0-1.995-.457-2-.46V19a1 1 0 0 0 1 1h3v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5h3a1 1 0 0 0 1-1v-8.46c-.002 0-.752.46-2 .46-2.08 0-2.984-1.247-3-1.27zM10 20h4v-5h-4v5zM5 4a1 1 0 0 0-1 1v2a2 2 0 1 0 4 0 1 1 0 0 1 2 0 2 2 0 1 0 4 0 1 1 0 1 1 2 0 2 2 0 1 0 4 0V5a1 1 0 0 0-1-1H5z", fill: "" })));
}
export var StoreIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: Store }, props))); };
//# sourceMappingURL=StoreIcon.js.map